module.exports = __webpack_public_path__ + "static/media/IconClients.5e000581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconClients.svg
// module id = 941
// module chunks = 0